<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div>
          <Breadcrumbs :breadcrumbs="breadcrumbs"/>
        </div>
        <div>
          <table class="table table-hover table-sm mt-1">
            <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Города</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="div in getSortedStores()">
              <td>{{ div.id }}</td>
              <td>{{ div.title }}</td>
              <td>
                <p class="mb-1" v-for="city in div.cities">{{ city.city.name }}</p>
              </td>
              <td>
                <button @click="mixinGoToRouter('BranchStoreStatus', {id: div.stores[0].object_id})"
                        class="btn btn-outline-info">Наличие
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  title: 'Склады',
  components: {
    Breadcrumbs
  },
  data() {
    return {
      breadcrumbs: [
        {title: 'Все склады'}
      ],
    }
  },
  computed: {
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  methods: {
    getSortedStores() {
      let list = []
      list.push({...this.$AllStores[2], stores: [{object_id: this.$AllStores[2].id}]})
      list.push({...this.$AllStores[30], stores: [{object_id: this.$AllStores[30].id}]})
      list.push({...this.$AllStores[34], stores: [{object_id: this.$AllStores[34].id}]})
      list.push({id: 1, title: 'Списание', stores: [{object_id: 1}]})

      list.push(this.$AllDivisions[1])
      list.push(this.$AllDivisions[4])
      list.push(this.$AllDivisions[7])
      list = [...list, ..._.orderBy(Object.values(this.$AllDivisions).filter((d) => d.is_active && ![1, 4, 7].includes(d.id)), 'title')]

      return list
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 5px;
}
</style>
